import type { HeaderGroup, RowData } from "@tanstack/table-core";
import { Virtualizer } from "@tanstack/virtual-core";
import { containerGridStyles } from "../utils/grid";
import { TableHeadCell } from "./cell";

interface TableHeadRowProps<D extends RowData> {
  columnVirtualizer: Virtualizer<HTMLDivElement, HTMLTableCellElement>;
  headerGroup: HeaderGroup<D>;
  virtualPaddingLeft: number | undefined;
  virtualPaddingRight: number | undefined;
}
export function TableHeadRow<D extends RowData>({
  columnVirtualizer,
  headerGroup,
  virtualPaddingLeft,
  virtualPaddingRight,
}: TableHeadRowProps<D>) {
  const virtualColumns = columnVirtualizer.getVirtualItems();

  return (
    <tr
      key={headerGroup.id}
      style={{ width: "100%", ...containerGridStyles }}
      className="w-full"
    >
      {virtualPaddingLeft ? (
        //fake empty column to the left for virtualization scroll padding
        <th
          key="virtual-padding-left"
          style={{ display: "flex", width: virtualPaddingLeft }}
        />
      ) : null}
      {virtualColumns.map((virtualColumn) => {
        const header = headerGroup.headers[virtualColumn.index];
        return <TableHeadCell key={header.id} header={header} />;
      })}
      {virtualPaddingRight ? (
        //fake empty column to the right for virtualization scroll padding
        <th
          key="virtual-padding-right"
          style={{ display: "flex", width: virtualPaddingRight }}
        />
      ) : null}
    </tr>
  );
}
